module.exports = __webpack_public_path__ + "static/media/contact-icon.55e901ba.55e901ba.JPG";